import { Component, computed, input } from '@angular/core';
import { PowerOutage } from '../../../../models/power-outage.model';
import { DecimalPipe } from '@angular/common';
import { DateWithFallbackPipe } from '../../../../pipes/date-with-fallback.pipe';

@Component({
  selector: 'app-outage-description',
  imports: [DecimalPipe, DateWithFallbackPipe],
  templateUrl: './outage-description.component.html',
  styleUrl: './outage-description.component.css',
})
export class OutageDescriptionComponent {
  readonly outage = input.required<PowerOutage>();

  protected readonly plannedStatusText = computed(() => {
    const now = new Date();
    const end = this.outage().plannedRectifyEnd;

    if (end && now > end) {
      return 'Vi beklager at den planlagte strømutkoblingen har gått over tiden. Vårt personell jobber med å ferdigstille arbeidet.';
    } else {
      return 'Vi oppgraderer strømnettet og må koble ut strømmen for at vårt personell skal kunne jobbe trygt.';
    }
  });
}
